import styled from "styled-components";

export const GenericWrapper = styled.div`
  display: grid;
  width: 100vw;
  min-height: 100vh;
  grid-template-columns: auto 1fr;
  grid-template-rows: 4.375rem auto 1fr;
  grid-template-areas:
    "header header"
    "main ${({ hideSide }) => (hideSide ? "main" : "sidebar")}"
    "footer footer";

  ${({ theme }) => theme.mq.lg`
    grid-template-rows: 4.375rem auto fit-content(15.625rem);
    grid-template-areas:
      "header header"
      "main main"
      "footer footer";
  `}
`;

export const Header = styled.nav`
  background-color: ${({ theme }) => theme.themeColors.white};
  box-shadow: ${({ theme }) => theme.settings.shadows.boxShadow};
  display: flex;
  grid-area: header;
  height: 4.375rem;
  justify-content: space-between;
  width: 100%;
  z-index: 5;
`;

export const LogoWrapperLg = styled.div`
  display: none;
  margin: auto 1.875rem;

  ${({ theme }) => theme.mq.lg`
    margin: auto 0 auto 1.875rem;
    display: block;
  `};
`;

export const LogoWrapperMd = styled.div`
  display: block;
  margin: auto 1.5625rem;

  ${({ theme }) => theme.mq.lg`
    margin: auto 0 auto 1.875rem;
    display: none;
  `};
`;
